import request from '../../../utils/request'

// 获取列表TABLE LIST
export const getTableList = params =>
  request.post('/workflow-api/credit-batch/upload/page', params)
// DOWNLOAD FILE
export const downloadFile = id =>
  request.get(
    `/workflow-api/credit-batch/download/${id}`,
    {},
    { responseType: 'blob' },
  )
// BATCH REQUEST DETAIL
export const getBatchDetail = bpmId =>
  request.get(`/workflow-api/credit-batch/task/detail/${bpmId}`)

// vague search
export const vagueSearch = params =>
  request.get(`/workflow-api/credit-batch/apply/listApprovePerson`, params)

// submit -> submit
export const handleDetailSubmit = params =>
  request.post(`/workflow-api/credit-batch/apply`, params)

// trans# -> pass
export const handleAudit = params =>
  request.post('/workflow-api/credit-batch/approve', params, {
    timeout: 300000,
  })

// pending-list table list
export const getPendingList = params =>
  request.post('/workflow-api/credit-batch/task/page', params)

// download template
export const downloadTemplate = params =>
  request.get('/workflow-api/credit-batch/template/download', params, {
    responseType: 'blob',
  })
// 下载文件
export const getFile = params =>
  request.get(
    `/workflow-api/credit-apply/attachment/download/${params.id}`,
    {},
    { responseType: 'blob' },
  )
